export default {
  en: {
    placeholder: 'Start writing',
    exitEditMode: 'Cancel edit',
    aria_new: {
      chat_message: 'Chat message',
      remove_file: 'Remove file',
      submit: 'Send message',
    },
  },
};
